import CallIcon from "@mui/icons-material/Call";
import IconButton from "@mui/material/IconButton";
import PropTypes from "prop-types";
import React from "react";
import { default as UserType } from "venuescanner-js/constants/user_type";
import Call from "venuescanner-js/react/components/Inbox/components/Chat/Call";

const CallButton = ({
  thread,
  venue,
  activeUser,
  isMobileDevice,
  styles = {},
}) => {
  const contactName =
    venue.contact_info.name || (thread._host && thread._host.name);

  return (
    <IconButton
      sx={{
        bgcolor: "primary.main",
        color: "common.white",
        height: "32px",
        width: "32px",
        marginRight: { sm: "1rem", md: 0 },
        ":hover": {
          bgcolor: "primary.dark",
        },
        ...styles,
      }}
      aria-label={`Call ${
        thread.viewerRole === UserType.organiser ? "venue" : contactName
      }`}
      onClick={() => {
        Call({
          calleeName: contactName,
          myNumber:
            activeUser._subjects._value.preferred_phone_number ||
            activeUser._subjects._value.phone,
          threadId: thread._id,
          fullscreen: isMobileDevice,
        });
      }}
    >
      <CallIcon />
    </IconButton>
  );
};

CallButton.propTypes = {
  thread: PropTypes.object.isRequired,
  venue: PropTypes.object.isRequired,
  activeUser: PropTypes.object.isRequired,
  isMobileDevice: PropTypes.bool.isRequired,
  styles: PropTypes.object,
};

export default CallButton;
